/**
 * Created by user on 2019/5/9.
 */

export * from '@lazy-cjk/zh-table-greedy';
import m from '@lazy-cjk/zh-table-greedy';

export default m;
